
import HttpClient from '../HttpService';

function getById(requestId) {
    return HttpClient.get(`/records/${requestId}`);
}

function getByUUID(uuid) {
    return HttpClient.get(`/records/uuid/${uuid}`);
}

function create(data) {
    return HttpClient.post(`/records`, data);
}

function list(page, limit, patientId) {
    return HttpClient.post(`/records/list/${patientId}?page=${page}&limit=${limit}`);
}

function listCompany(page, limit, data) {
    return HttpClient.post(`/records/list?page=${page}&limit=${limit}`, { ...data });
}

function listByPatientUUID(page, limit, patientUUID) {
    return HttpClient.post(`/records/list/uuid/${patientUUID}?page=${page}&limit=${limit}`);
}

function update(data) {
    return HttpClient.put(`/records/uuid/${data.uuid}`, data);
}

function destroy(uuid) {
    return HttpClient.delete(`/records/uuid/${uuid}`);
}

export default {
    list,
    listCompany,
    listByPatientUUID,
    create,
    update,
    destroy,
    getById,
    getByUUID,
}
